import Dropdown from "bootstrap/js/dist/dropdown";
import $ from 'jquery';

// fixed header script
window.onscroll = function() {
    fixedHeader()
};

const header = document.querySelector('.header')

const fixedHeader = () => {
    if (window.pageYOffset > 0) {
        header.classList.add('header--fixed')
    } else {
        header.classList.remove('header--fixed')
    }
}

(function(){
    var dropdownElementList = [].slice.call(document.querySelectorAll('.dropdown-toggle'))
    dropdownElementList.map(function (dropdownToggleEl) {
        return new Dropdown(dropdownToggleEl);
    })
})();

$('.ct-expand-button').on('click', function () {
    $(this).parent().toggleClass('hidden');
    $(this).find('.fa-bars').toggleClass('hidden');
    $(this).find('.fa-xmark').toggleClass('hidden');
});